import { useCallback, useMemo, useState, type ReactNode } from 'react';
import type { DocType } from '@/api/docs';
import { DocViewer } from './DocViewer';
import { DocViewerContext, type DocViewerContextValue } from './DocViewerContext';

interface State {
  type: DocType | null;
  id: number | null;
  docNo?: string;
  partyPhone?: string;
}

export function DocViewerProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<State>({ type: null, id: null });

  const open = useCallback<DocViewerContextValue['open']>((type, id, docNo, partyPhone) => {
    setState({ type, id, docNo, partyPhone });
  }, []);

  const close = useCallback(() => setState({ type: null, id: null }), []);

  const value = useMemo<DocViewerContextValue>(() => ({ open }), [open]);

  return (
    <DocViewerContext.Provider value={value}>
      {children}
      <DocViewer type={state.type} id={state.id} docNo={state.docNo} partyPhone={state.partyPhone} onClose={close} />
    </DocViewerContext.Provider>
  );
}
